import React, { useState, useEffect } from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { useForm } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import useValidation from '../../common/utils/validationRules';
import { useLoader } from '../../common/component/LoaderProvider';
import CommonModal from '../../common/component/commonModal';
import CommmonTable from '../../common/component/commonTable';
import { useDispatch, useSelector } from 'react-redux';
// import { onJustReducerUpdate } from '../../redux/action';
import { onJustReducerUpdate } from '../../service/action/actioncreator/DashboardAction/Dashboard'
// import { DASHBOARDLISTDATA } from '../../constant/constant';
import { DASHBOARDLISTDATA } from '../../service/action/actiontype/DashboardType/Dashboard'
import ConfirmAlert from '../../common/component/commonAlert';
import { useToast } from '../../common/component/Toast'
import CommonLoader from '../../common/component/commonLoader';
import { dashboardCall } from '../../service/action/actioncreator/DashboardAction/Dashboard';
import CommonOtpModal from '../../common/component/commonOtpModal';
import isEmpty from 'lodash';
import moment from 'moment';
import { TabMenu } from "primereact/tabmenu";
import infoImg from '../../assests/images/Info outline.png'
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import ChartAll from '../../common/component/chart';
import CommonCheckbox from '../../common/component/commonCheckBox';
import CommonProgressBar from '../../common/component/commonProgressBar';
import downButton from '../../assests/images/Down Button.png';
import hyphenIndicator from '../../assests/images/indicatore.png'

const centerTextPlugin = {
  id: "centerText",
  beforeDraw(chart) {
    const { width } = chart;
    const { height } = chart;
    const { ctx } = chart;
    const centerTextOptions = chart.options.plugins.centerText || {};
    const text = centerTextOptions.text || "";
    const innerBgColor = centerTextOptions.innerBgColor || "#FFF5EB";

    let circleRadius = 30;

    if (window.innerWidth >= 768 && window.innerWidth <= 1700) {

      circleRadius = Math.min(width, height) * 0.1;
    } else if (window.innerWidth < 768) {

      circleRadius = 20;
    } else if (window.innerWidth > 1700) {

      circleRadius = 40;
    }

    const centerX = width / 2;
    const centerY = height / 2;

    ctx.save();

    ctx.beginPath();
    ctx.arc(centerX, centerY, circleRadius, 0, 2 * Math.PI);
    ctx.fillStyle = innerBgColor;
    ctx.fill();
    ctx.closePath();

    // Adjust font size based on width
    const fontSize = window.innerWidth >= 768 && window.innerWidth <= 1700 ? "bold 20px Arial" : "bold 24px Arial";
    ctx.font = fontSize;
    ctx.fillStyle = "#FF6B6B";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(text, centerX, centerY);

    ctx.restore();
  },
};

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ArcElement);
ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.register(centerTextPlugin);


const DashBoardContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedData, setSelectedData] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const [dashboardContent, setDashboardContent] = useState({});
  const [modalFlag, setModalFlag] = useState()
  const [otpSelectionFlag, setOtpSelectionFlag] = useState(false);
  const [otpCodeFlag, setOtpCodeFlag] = useState(false);
  const [dashboardList, setDashboardList] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0);
  const [clickedMonth, setClickedMonth] = useState(null);


  const dispatch = useDispatch();
  // const profileDetails = useSelector((state) => state.loginDetails);
  const { validateField } = useValidation();
  const { showToast } = useToast();

  const userDetails = useSelector(state => state.dashboardReducer)

  const check = useSelector(state => state)

  const loading = useSelector(state => state.dashboardReducer.dashboardLoading)

  const otpOptions = [
    { label: 'SMS', value: 'SMS' },
    { label: 'Mail', value: 'Mail' },
    { label: 'Twilio Apps Authy', value: 'Twilio Apps Authy' }
  ]
  const { register, handleSubmit, formState: { errors }, setValue, getValues, control, reset } = useForm();

  const {
    register: registerOtp,
    handleSubmit: handleSubmitOtp,
    formState: { errors: errorsOtp },
    getValues: getValuesOtp,
    setValue: setValueOtp,
    control: controlOtp,
    reset: resetOtp,
    clearErrors
  } = useForm({
    mode: "onSubmit",
    defaultValue: {
      selectedOption: 'SMS',
      toggleValue: false,

    }
  });

  const langOptions = [

    { label: 'Tamil', value: 'TA' },
    { label: 'English', value: 'EN' },
    { label: 'Spanish', value: 'SP' },
  ];

  const statusOption = [
    { label: 'Agent A', value: 'Agent A' },
    { label: 'Agent B', value: 'Agent B' },
    { label: 'Agent C', value: 'Agent C' },
    { label: 'Agent D', value: 'Agent D' },
  ]

  const roleOptions = [
    { label: 'Developer', value: 'Developer' },
    { label: 'Tester', value: 'Tester' },
    { label: 'Devops', value: 'Devops' },
  ]
  //
  const formFields = [
    {
      type: "input",
      name: "FirstName",
      label: "First Name",
      placeholder: "Enter your first name",
    },
    {
      type: "input",
      name: "LastName",
      label: "Last Name",
      placeholder: "Enter your last name",
    },
    {
      type: "input",
      name: "Email",
      label: "Email",
      placeholder: "Enter your email",
    },
    {
      type: "dropdown",
      name: "Language",
      label: "Language",
      // options: [
      //   { value: "en", label: "English" },
      //   { value: "fr", label: "French" },
      //   { value: "es", label: "Spanish" },
      // ],
      placeholder: "Select a language",
    },
    {
      type: "radio",
      name: "Status",
      label: "Status",
    },
    {
      type: "datePicker",
      name: "Date",
      label: "Select the Date",
      placeholder: "Select the Date Range"
    },
    {
      type: "phone",
      name: "PhoneNumber",
      label: "Phone Number",
      placeholder: "Enter your PhoneNumber",
    },
    {
      type: "activeStatus",
      name: "toggleValue",
      label: "Agent Status",
    },
    {
      type: "checkbox",
      name: "Role",
      label: "Select Your Role"
    }
  ]
  const items = [
    { label: "Generale" },
    { label: "Ordini" },
    { label: "Farmaci" },
    { label: "Assistiti" },
  ];

  const checkboxDoughnutItems = [
    { label: 'invio ordinatvi a solletci', value: 'invio ordinatvi a solletci' },
    { label: 'Acquisization survey', value: 'Acquisization survey' },
    { label: 'inivi reminder assisti', value: 'inivi reminder assisti' }
  ]

  // 

  const columnData = []


  // useEffect(() => {
  //     dispatch(onJustReducerUpdate(columnData, DASHBOARDLISTDATA));
  // }, []);

  useEffect(() => {
    if (userDetails?.dashboardLoading) {
      // loading
    } else if (userDetails?.dashboardResponse) {
      // success
    } else if (userDetails?.dashboardError) {
      //  error
    }
  }, [userDetails])

  useEffect(() => {
    dispatch(dashboardCall(showToast, showLoader, hideLoader))
  }, [])

  const isDashboardData = useSelector(state => state.dashboardReducer.dashboardList);

  useEffect(() => {
    const name = selectedData?.Name.split(' ');
    setValue('FirstName', name?.[0]);
    setValue('LastName', name?.[1]);
    setValue('Email', selectedData?.Email);
    setValue('Language', langOptions.find((obj) => obj?.value === selectedData?.Language)?.value);
    setValue('Agent', selectedData?.Status)
    setValue('PhoneNumber', selectedData?.PhoneNumber)
    var setDate = new Date(selectedData?.Date)
    setValue('Date', setDate)
  }, [selectedData]);

  useEffect(() => {
    setDashboardContent(isDashboardData);
    setDashboardList(true)
  }, [isDashboardData]);

  useEffect(() => {
    ChartJS.register(centerTextPlugin);
    return () => {
      ChartJS.unregister(centerTextPlugin);
    };
  }, []);
  // useEffect(() => {
  //   return () => {
  //     // hideLoader();
  //   };
  // }, []);

  const handleSearchChange = (e) => {
    const searchValue = e?.target?.value?.toLowerCase();
    setSearchTerm(searchValue);


    // const filteredContent = columnData?.filter((row) => {
    //     return Object.values(row).some(
    //         (value) =>
    //             value &&
    //             value.toString().toLowerCase().includes(searchValue)
    //     );
    // });

    const filteredData = dashboardContent.filter((row) => {
      return Object.values(row).some(
        (value) =>
          value &&
          value.toString()?.toLowerCase().includes(searchTerm?.toLowerCase())
      );
    });

    dispatch(onJustReducerUpdate(filteredData, DASHBOARDLISTDATA));

  };

  const handleReset = () => {
    reset({
      FirstName: "",
      LastName: "",
      Email: "",
      Language: "",
      Agent: "",
      PhoneNumber: ""
    });
  };

  const handleEditData = (rowData) => {
    setSelectedData(rowData);
    // setIsModalOpen(true);
    setOtpSelectionFlag(true)
    setModalFlag("edit")
  };

  const handleDeleteData = (rowData) => {
    setSelectedData(rowData);
    setShowConfirm(true);
  };


  const onConfirm = () => {
    setShowConfirm(false);
    // const updatedContent = dashboardContent?.tableContent?.filter(row => row?.id !== selectedData?.id);
    const updatedContent = dashboardContent?.filter(row => row?.id !== selectedData?.id);
    setDashboardContent(updatedContent)
    // setDashboardContent({
    //     ...dashboardContent,
    //     tableContent: updatedContent,
    // });
    dispatch(onJustReducerUpdate(updatedContent, DASHBOARDLISTDATA));
  };
  const handleModalSubmit = (data) => {
    if (modalFlag === 'edit') {
      var updateDate = moment(new Date(data?.Date)).format('YYYY-MM-DD')
      var dataValue = dashboardContent?.forEach((obj) => {

        if (obj.id === selectedData?.id) {
          obj.Name = `${data.FirstName} ${data.LastName}`;
          obj.Email = data?.Email;
          obj.Language = data?.Language;
          obj.Date = updateDate;
          obj.PhoneNumber = updateDate
        }


      })
      // setDashboardContent(dataValue)
      dispatch(onJustReducerUpdate(dashboardContent, DASHBOARDLISTDATA));
      // setDashboardContent(dataValue)
      // showToast('success','Sucsess', 'Updated the Record Successfully');

    } else if (modalFlag === 'add') {
      var addDate = moment(new Date(data?.Date)).format('YYYY-MM-DD')
      const updatedObj = {
        Name: `${data.FirstName} ${data.LastName}`,
        Email: data.Email,
        Language: data.Language,
        Country: null,
        Agent: data.Status,
        Date: addDate
      };

      // showToast('success','Success', 'Added the Record Successfully');
      // var dataValue = dashboardContent.tableContent.push(updatedObj)
      // dashboardContent.tableContent?.splice(0, 0, updatedObj);
      var dataValue = dashboardContent?.splice(0, 0, updatedObj);

      // setDashboardContent(dataValue)
    }


    //   setDashboardContent({
    //     ...dashboardContent,
    //     tableContent: dataValue,
    // });

    setIsModalOpen(false);
    handleReset();
    handleResetOtp();
  };

  const onHide = () => {
    setShowConfirm(false);
    // handleReset();
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setOtpSelectionFlag(false)
    setOtpCodeFlag(false)
    handleReset();
    handleResetOtp();
  };
  const handleRegister = () => {
    handleReset();
    setModalFlag("add")
    setIsModalOpen(true);
  }
  const handleModalSubmitOtp = (data) => {
    setOtpSelectionFlag(false)
    setOtpCodeFlag(true)
    if (data?.otp?.length > 0) {
      setOtpCodeFlag(false)
      setIsModalOpen(true)
      // dispatch(onJustReducerUpdate(columnData, DASHBOARDLISTDATA));
    }
  }
  const handleModalCloseOtp = () => {
    setOtpSelectionFlag(false)
    setOtpCodeFlag(false)
    setIsModalOpen(false)
    handleResetOtp();
  }

  const handleResetOtp = () => {
    resetOtp({
      selectedOption: 'SMS',
      otp: ''
    })
  }
  const months = ['Oct', 'Nov', 'Dec'];

  const data = {
    labels: months,
    datasets: [
      {
        label: 'Dataset 1',
        data: [3, 7, 6, 5],
        backgroundColor: months.map((month, index) => {
          // If the month is before the clicked month, fade it out
          if (clickedMonth && index < months.indexOf(clickedMonth)) {
            return 'rgb(100,191,250)'; // Faded color
          }
          return 'rgb(14,101,255,1)'; // Normal color
        }),
        borderColor: months.map((month, index) => {
          if (clickedMonth && index < months.indexOf(clickedMonth)) {
            return 'rgb(100,191,250)';
          }
          return 'rgb(14,101,255,1)';
        }),
        borderWidth: 1,
        borderRadius: 10,
        barThickness: 40,
      },
      {
        label: 'Dataset 2',
        data: [10, 2, 3],
        backgroundColor: months.map((month, index) => {
          if (clickedMonth && index < months.indexOf(clickedMonth)) {
            return 'rgb(250,196,101)'; // Faded color
          }
          return 'rgb(248,177,51,1)'; // Normal color
        }),
        borderColor: months.map((month, index) => {
          if (clickedMonth && index < months.indexOf(clickedMonth)) {
            return 'rgb(250,196,101)';
          }
          return 'rgb(248,177,51,1)';
        }),
        borderWidth: 1,
        borderRadius: 10,
        barThickness: 40,
      },

    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    devicePixelRatio: 2,
    plugins: {

      legend: {
        display: false,
        // position: 'top',
      },
      tooltip: {
        enabled: true,
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const clickedIndex = elements[0].index;
        const clickedMonth = months[clickedIndex];
        setClickedMonth(clickedMonth);
      }
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          callback: (value, index) => {
            return months[index];
          },
        },
      },
      y: {
        stacked: true,
      },
    },
  };

  const rawData = [30, 20, 17];
  const total = rawData.reduce((sum, value) => sum + value, 0);
  const gap = total < 100 ? 100 - total : 0;

  const doughnutData = {
    labels: ["Category 1", "Category 2", "Category 3", "Gap"],
    datasets: [
      {
        data: [...rawData, gap],
        backgroundColor: [
          "#FF6B6B",
          "#FFD93D",
          "#6BCB77",
          "#FFFFFF",
        ],
        hoverBackgroundColor: [
          "#FF6B6B",
          "#FFD93D",
          "#6BCB77",
          "#FFFFFF",
        ],
        borderWidth: 5,
        borderRadius: 20,
        borderColor: "#fff",
        hoverBorderColor: "#fff",
      },
    ],
  };

  //

  const doughnutOptions = {
    cutout: "80%",
    rotation: -90,
    circumference: 360,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },

      centerText: {
        text: "67%",
        innerBgColor: "#FFF5EB",
        circleRadius: 40,
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const dataset = tooltipItem.dataset;
            const index = tooltipItem.dataIndex;
            const value = dataset.data[index];
            return index === dataset.data.length - 1 && gap > 0
              ? `Gap: ${value}%`
              : `${value}%`;
          },
        },
      },
    },
  };

  return (

    <div className="dashboard-content">
      <h3 className="secondary-text-color fw-bold ms-4">DASHBOARD</h3>
      <div className="mt-0 p-0 navbar-align">
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          className="custom-tabmenu"
        />

        <div className="tab-content">
          {activeIndex === 0 && (
            <>
              <div
                className="d-flex  justify-content-between align-items-center  "
                style={{  gap:10}}>
                <div style={{
                  height:'170px',
                  paddingTop:10,
                  overflow:'hidden'


                }} className="col-lg-7  col-xl-4 col-sm-12" 

                
                >
                  <div className="card h-100 p-xl-2 p-sm-4 rounded-4"
                  style={{ 
                  
                  }}
                   >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="block table-text-color font-align-card font-medium">Ordini farmaci</span>
                      </div>
                      <img src={infoImg} className="" />
                    </div>

                    <div className="container1">
                      <div className="d-flex justify-content-between align-items-center"
                    
                      >
                        <div className="primary-font-size ">
                          <h3 className="primary-text-color mt-3 fw-bold font-align-sub">120</h3>
                          <span className="secondary-text-color small">Totale ordini</span>
                        </div>
                        <div className="border-end mt-3 ms-2" style={{ height: "5rem", borderWidth: "1px" }}></div>
                        <div className=" primary-font-size">
                          <h3 className="secondary-text-color  mt-3 fw-bold font-align-sub ms-2">108</h3>
                          <div className="d-flex flex-row justify-content-between align-items-center">
                            <span className="secondary-text-color small ms-2">Completati</span>
                            <span className="secondary-text-color small ms-3">90%</span>
                          </div>
                        </div>
                        <div className="border-end primary-font-size mt-3 ms-2" style={{ height: "5rem", borderWidth: "1px" }}></div>
                        <div>
                          <h3 className="secondary-text-color mt-3 fw-bold font-align-sub ms-2">12</h3>
                          <span className="secondary-text-color small ms-2">In Sospeso</span>
                          <span className="secondary-text-color small ms-3 ms-2">10%</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                <div
                style={{
                  height:'170px',
                  paddingTop:10

                }}
                  className="col-lg-4  col-xl-3 col-sm-12"
                >
                  <div
                    className="card  h-100 p-xl-2 p-sm-4 rounded-4"
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="block font-medium table-text-color font-align-card ">Disponibilita farmaci</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="primary-font-size">

                        <h3 className="primary-text-color mt-3 fw-bold font-align-sub">15%</h3>
                        <span className="secondary-text-color small">Scorte sotto il limite di </span>
                      </div>

                    </div>
                  </div>
                </div>
                <div
                style={{
                  height:'170px',
                  paddingTop:15,
                  overflow:'hidden'

                }}
                  className="col-lg-7 col-xxl-4 col-xl-8 col-sm-12"
                >
                  <div className="card  h-100 p-xl-2 p-sm-4 rounded-4 "
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="primary-font-size">
                        <span className="block font-medium table-text-color font-align-card ">Assistiti Attivi/Total</span>
                        <h3 className="primary-text-color mt-3 fw-bold font-align-sub">450/600</h3>
                        <div className="d-flex flex-row justify-content-between align-items-center">
                          <span className="secondary-text-color small">Su base mensile</span>
                          <span className="secondary-text-color small ms-3">75%</span>
                        </div>
                      </div>
                      <div className="border-end mt-3 ms-2" style={{ height: "5rem", borderWidth: "1px" }}></div>
                      <div className="primary-font-size"
                      style={{
                        alignSelf:'center',
                        textAlign:'left'
                      }}
                      >
                        <span className="block text-muted font-medium">Adesione terapeutica</span>
                        <h3 className="secondary-text-color mt-3 fw-bold font-align-sub ms-2">85%</h3>
                        <span className="secondary-text-color small ms-2">Assissti consitenti alla terapia</span>
                      </div>


                    </div>
                  </div>
                </div>
              </div>



              <div className="row mt-4">
                {/* Chart Section */}
                <div className="col-lg-12 col-xl-8   col-sm-12 mt-3">
                  <div className="card  h-100 card-align">
                    <h5 className="secondary-text-color text-start">Trend Ordinativi</h5>
                    <div className="row d-flex">
                      <div className="col-lg-2 col-sm-2">
                        <div className="d-flex flex-column justify-content-between primary-font-size ms-3">
                          <h3 className="primary-text-color mb-0 mt-2 fw-bold">120</h3>
                          <span className="secondary-text-color small mt-2">Dic 2024</span>
                          <div className="d-flex justify-content-between mt-4">
                            <div>
                              <h3 className="primary-text-color mb-0 fw-bold">100</h3>
                              <span className="secondary-text-color small mt-2">Gen 2025</span>
                            </div>
                            <div>
                              <img src={downButton} alt="img" className="mt-4" />
                            </div>
                          </div>
                          <div className="d-flex justify-content-between mt-4">
                            <div>
                              <h3 className="primary-text-color mb-0 fw-bold">169</h3>
                              <span className="secondary-text-color small mt-2">Dec 2025</span>
                            </div>
                            <div>
                              <img src={hyphenIndicator} alt="img" className="mt-4" />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-10 col-sm-10">
                        <div
                          className="chart-container display-flex"
                          style={{
                            width: "100%",
                            height: "300px",
                            margin: "0 auto",
                          }}
                        >
                          <ChartAll
                            data={data}
                            options={options}
                            chartType="barChart"
                            style={{ width: "100%", height: "100%" }}
                            isMultiple={true}
                          />
                        </div>
                      </div>
                    </div>
                    <p className="mt-4 small text-start secondary-text-color">
                      Andamento mensile degli ordinativi complessivi con specifica di quelli soglia critica di approvvigionamento previsionale
                    </p>
                  </div>
                </div>

                <div className=" col-xl-4 col-lg-12 col-sm-12 mt-3">
                  <div className="card h-100 card-align">
                    <h5 className="secondary-text-color text-start">Completamento Task Dicembre 2024</h5>
                    <div className="row d-flex">
                      <div className="col-md-6 col-xl-6 primary-font-size">
                        <div
                          className="chart-container display-flex ms-3"
                          style={{
                            width: "100%",
                            height: "200px",
                            margin: "0 auto",
                          }}
                        >
                          <ChartAll
                            doughnutData={doughnutData}
                            doughnutOptions={doughnutOptions}
                            chartType="semiDoughnut"
                            style={{ width: "100%", height: "100%" }}
                            plugins={[centerTextPlugin]}
                          />
                        </div>
                      </div>

                      <div className="col-md-6 col-xl-6 mt-5">
                        <CommonCheckbox
                          register={register}
                          control={control}
                          options={checkboxDoughnutItems}
                          name="doughtnutCheckdata"
                          getValues={getValues}
                          setValue={setValue}
                          isMultiple={true}
                        />
                      </div>
                    </div>
                    <p className="small mt-4 text-start secondary-text-color">
                      Attivita ricorsive mensili planificate
                    </p>
                  </div>
                </div>
              </div>



              {/* third col*/}

              <div
                className="row d-flex mt-4"
              >

                <div className="  col-lg-5  col-sm-12 mt-3">
                  <div className="card h-100 card-align">
                    <p className="secondary-text-color">Remainder completed dagli assisti</p>
                    <CommonProgressBar
                      dataRange={50}
                    />
                  </div>
                </div>

                <div className="  col-lg-7  col-sm-12 mt-3">
                  <div className="card  h-100 card-align">
                    <p className="secondary-text-color">Eventi avversi registrat</p>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="me-4">
                        <h3 className="primary-text-color mb-0 mt-2">45</h3>
                        <span className="secondary-text-color small">Totals</span>
                      </div>
                      <div className="border-end" style={{ height: "3rem", borderWidth: "1px" }}></div>
                      <div className="me-4">
                        <h3 className="secondary-text-color mb-0">27</h3>

                        <span className="secondary-text-color small">Leivi</span>
                        <span className="secondary-text-color small ms-3">60%</span>

                      </div>
                      <div className="border-end" style={{ height: "3rem", borderWidth: "1px" }}></div>
                      <div className="me-4">
                        <h3 className="secondary-text-color mb-0">14</h3>

                        <span className="secondary-text-color small">Moderati</span>
                        <span className="secondary-text-color small ms-3">32%</span>

                      </div>
                      <div className="border-end" style={{ height: "3rem", borderWidth: "1px" }}></div>
                      <div className="me-4">
                        <h3 className="secondary-text-color mb-0">4</h3>

                        <span className="secondary-text-color small">Gravi</span>
                        <span className="secondary-text-color small ms-3">8%</span>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </>
          )}
          {/*  */}

          {activeIndex === 1 && <div>Content for Ordini</div>}
          {activeIndex === 2 && <div>Content for Farmaci</div>}
          {activeIndex === 3 && <div>Content for Assistiti</div>}
        </div>
      </div>

    </div>
  );
};

export default DashBoardContent;
